import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
//import moment from '../moment/moment.min.js';
//npm install --save moment react-moment
import { format } from 'date-fns';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { saveAs } from "file-saver";

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Rendervsaform = () => {

const navigate = useNavigate();
	

/*
had an error with sessionStorage.getItem("RESTURL") returning null 
when below declaration was before this const Rendervsaform
*/
const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;


//getresturl();



window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const navVsaform = React.useRef();
const navWpvouchers = React.useRef();
const navVsastatus = React.useRef();

const [vsaapp, setVsaapp] = useState({VSA_APP_ID:''});
const [tblvsaapps, setTblvsaapps] = useState({
loaded:false
,newrows:[]
,unpdrows:[]
,pdrows:[]
,approvdrows:[]
,refusedrows:[]
,deferedrows:[]
,ovturndrows:[]
});
const [linkvsaform, setLinkvsaform] = useState({VSA_APP_ID:0});
const [linkvouchers, setLinkvouchers] = useState({VSA_APP_ID:0});
const [linkvsastatus, setLinkvsastatus] = useState({VSA_APP_ID:0});

let date1=new Date();
date1.setMonth(date1.getMonth() - 1);
date1.setDate(1);

const [searchcrit, setSearchcrit] = useState({
	txt:''
	, date1: date1.toISOString().slice(0, 10)
	, date2: new Date().toISOString().slice(0, 10)
	, caseworker: ''
	});
const startupMins=5;//here on test page this will be 10 seconds
const [reload, setReload] = useState({mins:startupMins});



const location = useLocation();
let reloadTimer=null;
//var currmins=10;
const timerEvent = () => {
	
	const currmins=1*(document.getElementsByName("inputminsremain")[0].value)-1;
	if (currmins>=0)
		setReload({mins:currmins});
	else{
		
		setReload({mins:startupMins});
	}
		

/*
	setReload((prev)=>{
		
		console.log("currmins: "+currmins); 
		return {...prev, mins:currmins}
		});

*/

	};

useEffect(() => {
//console.log('useEffect resturl: '+sessionStorage.getItem("RESTURL"));

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if


document.title =   "APS Applications";	
//return () => clearInterval(reloadTimer);
if (tblvsaapps.loaded==false){
	gettblvsaapps();
	}//end if
	
	
 },[]);



useEffect(() => {

if (reload.mins==startupMins)
	gettblvsaapps();

	if (document.getElementById('newapps')){
		const evt={
		currentTarget:document.getElementById('newapps')
		};
		//console.log("evt.currentTarget.className: "+evt.currentTarget.className);
		openCity(evt, "newappstc");
		}//end if
	document.getElementsByName('txt')[0].focus();
	
 },[reload.mins]);

useEffect(() => {


	console.log("reloadTimer: "+reloadTimer);
	if (reloadTimer==null)
		reloadTimer = setInterval(timerEvent, 1000*60);//*60
	else{

		}//end else

    // Stops the old timer when umount the component.
    return function stopTimer() {
      clearInterval(reloadTimer);
    }
		

 },[JSON.stringify(tblvsaapps)]);



 useEffect(() => {
	if (linkvsaform.VSA_APP_ID>0)
		navVsaform.current?.click();
 },[linkvsaform]);


 useEffect(() => {
	if (linkvsastatus.VSA_APP_ID>0)
		navVsastatus.current?.click();
 },[linkvsastatus]);


useEffect(() => {
	if (linkvouchers.VSA_APP_ID>0)
		navWpvouchers.current?.click();
 },[linkvouchers]);

useEffect(() => {
		gettblvsaapps();
 },[searchcrit]);

function searchcritChange(e){
	const {name, value} = e.target;
	setSearchcrit((prev)=>{
		return {...prev, [name]:value}
	});
	
	
}//end if


function getresturl(){
console.log('getresturl( location.state: '+JSON.stringify(location.state))	;
for(var attributename in location.state){
	if (attributename=='resturl')
		return location.state.resturl;
	}//end for	
return null;	
}//end func

function setCaseWorker(e){
	e.preventDefault();
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/setcaseworker',requestOptions)
      .then(res => res.json())
      .then(res => 	afterSetCaseWorker(res) )	
	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function afterSetCaseWorker(res){
if (res.length==undefined)
	showsnackbar("something went wrong.  please try again");
else{	
	showsnackbar("assigning case worker is complete");
	toggleModalsm();
	}
}//end func



async function visasxlreport(e){

e.preventDefault();

const nowstamp=format(new Date(), 'dd.MMMM.yyyy h.mm.ss');//yyyy/MM/dd kk:mm:ss
//const filename="Visas_Excel_Report_"+moment(new Date()).format('DD.MMMM.YYYY h.mm.ss A');
const filename="Visas_Excel_Report_"+nowstamp;

const params={
	username: sessionStorage.getItem("USERNAME")
	, date1:searchcrit.date1
	, date2:searchcrit.date2
	, filename:filename
	}


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	

if (e.target)  
	e.target.style.visibility='hidden';

 await fetch(resturl+'rarvsaform/visasxlreport',requestOptions)
      .then(res => 	aftervisasxlreport(res, filename, e) )
      .catch(err => console.log(err));

}//end func

async function aftervisasxlreport(res, filename, e){
	
	if (e.target)
		e.target.style.visibility='visible';	
	
	const blob = await res.blob();
	if (blob){
		saveAs(blob, filename+".xlsx");
		}
	else
		alert(JSON.stringify(res.json()));
	
}//end func

async function gettblvsaapps(){
//const resturl=sessionStorage.getItem("RESTURL");
//console.log('resturl: '+resturl);

let crit=searchcrit;
crit.dates=searchcrit.date1+','+searchcrit.date2;

const params={
	USERNAME: sessionStorage.getItem("USERNAME")
	, crit:crit
	}

//console.log(JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setTblvsaapps((prev)=>{
return {
	...prev
	,newrows:[]
	,unpdrows:[]
	,pdrows:[]
	,approvdrows:[]
	,refusedrows:[]
	,deferedrows:[]
	,ovturndrows:[]
	}	
});


 await fetch(resturl+'rarvsaform/gettblvsaapps',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblvsaapps(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblvsaapps(res){
if (res.length==undefined)
	return;

	
console.log('aftergettblvsaapps, res.length: '+res.length);

let newrows=[], unpdrows=[], pdrows=[], approvdrows=[], deferedrows=[], refusedrows=[], ovturndrows=[];
res.map((col, index) => {
	const appid=col['VSA_APP_ID'];
	const refnum=col['REF_NUM'];
	const STATUS=col['STATUS_CODE'];
	const CORPORATE=col['CORPORATE'];
	const CASE_WORKER=col['CASE_WORKER'];
	const submitted=col['SUBMITTED_TO_CSC'];
	const VOUCHERS_TOTAL_AMT=(col.VOUCHERS_TOTAL_AMT==null)?'':'$'+col.VOUCHERS_TOTAL_AMT;
	const trkey='tr_'+appid;
	//const rdkey='rd_'+appid;
	const refnumLink=<a href="#" className="nodecor" onClick={(e)=>{handleWpappChange(e, appid, STATUS, submitted);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{refnum}<span className='tooltiptext'>open this application</span></a>;
	//const voucherLink=<a href="#" className="nodecor" onClick={(e)=>{vouchersLink(e, appid);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{VOUCHERS_TOTAL_AMT}<span className='tooltiptext'>vouchers and payment</span></a>;
	
	//const pdflink=sessionStorage.getItem("UPLOADURL")+refnum+"/coverpage.pdf";	
	
	
	const htmrow=<tr key={trkey} >
	<td align='left' className='tooltip' >&nbsp;{refnumLink}</td>
	<td align='left' >{col['SURETY_NAME']}</td>
	<td align='left' >{col['STY_MBL_PHN']}</td>
	<td align='left' >{col['APPLICANT_NAME']}</td>
	<td align='left' >{col['VSA_TYP']}</td>
	<td align='left' >{col['STATUS']}</td>
	<td align='left' >{col['VISA_STATUS']}</td>

		{/*<td align='right' className="tooltip" >{voucherLink}&nbsp;</td>*/}
	<td align='center' >{col['MODIFY_DATE_TIME']}</td>
	<td align='center' className="tooltip" >
	<span className='tooltiptext'>view the applicaiton form fields</span>
	<a href='#' onClick={(e)=>{viewvsaform(e, appid);}} className="nodecor" >{col['SUBMITTED_TO_CSC']}</a>   
	</td>
	<td align='left'  >{col['LBR_CLR_REF']}</td>
	</tr>;
	if (STATUS=='NEW' || STATUS=='NOTSUBMIT')
		newrows.push(htmrow);
	else if (STATUS=='VCHRSNOTPAID')
		unpdrows.push(htmrow);
	else if (STATUS=='VCHRSPAID')
		pdrows.push(htmrow);
	else if (STATUS=='APPROVED')
		approvdrows.push(htmrow);
	else if (STATUS=='DEFERRED')
		deferedrows.push(htmrow);
	else if (STATUS=='REFUSED')
		refusedrows.push(htmrow);
	else if (STATUS=='OVERTURN BY MINISTER')
		ovturndrows.push(htmrow);
});

setTblvsaapps({
loaded:true
,newrows:newrows	
,unpdrows:unpdrows	
,pdrows:pdrows	
,approvdrows:approvdrows	
,refusedrows:refusedrows	
,deferedrows:deferedrows	
,ovturndrows:ovturndrows	

});
}//end func


function viewvsaform(e, VSA_APP_ID){
console.log('viewvsaform VSA_APP_ID: '+VSA_APP_ID);
e.preventDefault();
setLinkvsaform({VSA_APP_ID:VSA_APP_ID});
	{/*
	setLinkvsaform();
if (navVsaform.current)
	navVsaform.state={VSA_APP_ID:VSA_APP_ID};
navVsaform.current?.click();

	*/}

}//end func





function vouchersLink(e, appid){
	console.log('setLinkvouchers '+appid);
	e.preventDefault();
	setLinkvouchers({VSA_APP_ID:appid});

}//end func


function handleWpappChange(e, appid, STATUS, submitted){
	e.preventDefault();
	
	//console.log('handleWpappChange IRD_LOGIN_ID: '+sessionStorage.getItem("IRD_LOGIN_ID"));
	console.log('submitted: '+submitted);
	
	//return;
	setLinkvsaform({VSA_APP_ID:appid, SUBMITTED_TO_CSC:submitted});
/*
	if (sessionStorage.getItem("IRD_LOGIN_ID")==undefined || sessionStorage.getItem("IRD_LOGIN_ID")==null || submitted==null)
		setLinkvsaform({VSA_APP_ID:appid});
	else{
		console.log('USERNAME: '+sessionStorage.getItem("USERNAME"));
		console.log('STATUS: '+STATUS);
		
		if ((STATUS=='VCHRSPAID' || STATUS=='NEW' ) && sessionStorage.getItem("USERNAME")!='' && sessionStorage.getItem("USERNAME")!=null && sessionStorage.getItem("USERNAME")!=undefined)
			setLinkvsastatus({VSA_APP_ID:appid});
		else
			setLinkvouchers({VSA_APP_ID:appid});
		}//end else

*/		

}//end func


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

function openCity(evt, cityName) {
	
	console.log("openCity: "+cityName);
	
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

if (evt)
  evt.currentTarget.className += " active";
}//end func


const theadcells=<>
	<tr>
		<th>WP portal ref #</th>
		<th>surety's name</th>
		<th>surety's phone #</th>
		<th>applicant</th>
		<th>visa type</th>
		<th>status I</th>
		<th>status II</th>
		<th>last update</th>
		<th>submitted to<br/>customer service</th>
		<th>immigration<br/>reference #</th>
	</tr>

</>;

	
  return (
    <>

<table align='center' width="75%" style={{marginTop:"10px", marginBottom:"10px"}}>
<tbody>
<tr>
<td align='center'><input name="date1" type="date" value={searchcrit.date1} onChange={(e)=>{searchcritChange(e);}} /></td>
<td align='center'><input name="date2" type="date" value={searchcrit.date2} onChange={(e)=>{searchcritChange(e);}} /></td>
<td align='center'><a href="#" className="nodecor" onClick={(e)=>{visasxlreport(e);}}  ><img src="img/excel.png" border="0" height="20" /> excel report</a></td>

<td align='center'>search criteria:&nbsp;<input name="txt" size='38' defaultValue={searchcrit.txt} autoComplete="off" onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='any name / ref # / visa type' /></td>
<td align='center' className='tooltip' ><input size="2" name="inputminsremain" value={reload.mins} style={{textAlign:"center"}} readOnly className="gnsbro" /><span className='tooltiptext'>minutes before reload</span></td>
	{/*<td align='center'><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/usergrp");}}  ><img src="img/user-circle.webp" border="0" height="20" /> users</a></td>*/}

</tr>
</tbody>
</table>
	
<div className="tab">
  <button className="tablinks" id='newapps'    onClick={(e)=>{openCity(e, e.target.id+"tc");}} ><span style={{color:"brown"}} >{tblvsaapps.newrows.length}</span> New Applications</button>
  <button className="tablinks" id='unpaidapps' onClick={(e)=>{openCity(e, e.target.id+"tc");}} ><span style={{color:"brown"}} >{tblvsaapps.unpdrows.length}</span> Unpaid Applications</button>
  <button className="tablinks" id='paidapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} ><span style={{color:"brown"}} >{tblvsaapps.pdrows.length}</span> Paid Applications</button>
  <button className="tablinks" id='approvdapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} ><span style={{color:"brown"}} >{tblvsaapps.approvdrows.length}</span> Approved</button>
  <button className="tablinks" id='deferedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} ><span style={{color:"brown"}} >{tblvsaapps.deferedrows.length}</span> Deferred</button>
  <button className="tablinks" id='refusedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} ><span style={{color:"brown"}} >{tblvsaapps.refusedrows.length}</span> Refused</button>
  <button className="tablinks" id='ovturndapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} ><span style={{color:"brown"}} >{tblvsaapps.ovturndrows.length}</span> Overturned</button>
</div>

<div id="newappstc" className="tabcontent">
  <h4 align='center' >Newly Submitted Applications to be checked.  After checking, payment vouchers prepared if the applicaiton is not refused</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.newrows}
	</tbody>
	</table>
</div>

<div id="unpaidappstc" className="tabcontent">
  <h4 align='center' >Applications with payment vouchers prepared and not yet paid</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.unpdrows}
	</tbody>
	</table>
</div>

<div id="paidappstc" className="tabcontent">
  <h4 align='center' >Applications with payment vouchers that have been paid</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.pdrows}
	</tbody>
	</table>
</div>	

<div id="approvdappstc" className="tabcontent">
  <h4 align='center' >Approved Applications</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.approvdrows}
	</tbody>
	</table>
</div>	

<div id="deferedappstc" className="tabcontent">
  <h4 align='center' >Deferred Applications</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.deferedrows}
	</tbody>
	</table>
</div>	

<div id="refusedappstc" className="tabcontent">
  <h4 align='center' >Refused Applications</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.refusedrows}
	</tbody>
	</table>
</div>	


<div id="ovturndappstc" className="tabcontent">
  <h4 align='center' >Overturned by Minister Applications</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.ovturndrows}
	</tbody>
	</table>
</div>	



	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			
			<p>you are not currently the case worker assigned to this application</p>
			<p>click the second button below if you will be the case worker assigned</p>
			<p>
			<button className="button" onClick={(e)=>{ toggleModalsm(); }} >Cancel</button>
			&nbsp;&nbsp;
			<button className="button" onClick={(e)=>{ setCaseWorker(e); }} >I will be the case worker assigned</button>
			</p>
			
			</div>
		</div>
	</div>

<div id="snackbar">&nbsp;</div>
          <NavLink
		  ref={navVsaform}
          to={"/vsaform"}
		  style={{display:"none"}}
          state={{
		  VSA_APP_ID:linkvsaform.VSA_APP_ID
		  }} 
        >
		&nbsp;click here to vsaform
        </NavLink>

		<NavLink ref={navWpvouchers} to={"/wpvouchers"} style={{display:"none"}} state={{VSA_APP_ID:linkvouchers.VSA_APP_ID}} >
		click here to vouchers
		</NavLink>
          
          <NavLink ref={navVsastatus} to={"/vsastatus"} style={{display:"none"}} state={{VSA_APP_ID:linkvsastatus.VSA_APP_ID}} >
		  click here to status
		  </NavLink>
		
		
		{/*
        <NavLink ref={navVsaform} to={"/vsaform"} style={{display:"none"}}
          state={{VSA_APP_ID:0}}  >vsaform</NavLink>
		*/}



    </>
  );
  


};


export default Rendervsaform;